export { JiraTemplateCategoryPageTemplate } from "./jira-template-category-page.template";
